import classNames from 'classnames';
import React from 'react';
import PropTypes from 'prop-types';

/**
 * Represents a group of steps. Can either be at the root level of a step wizard or be nested inside
 * an existing Step. This allows for multiple levels of steps.
 * @param {*} props - See propTypes declaration.
 * @returns {ReactNode} - Renders the currently selected step. Root level will be a provider of
 * StepsContext.
 */
export function StepContainer(props) {
  const {
    children,
    className,
    id,
  } = props;

  return (
    <div id={id} className={classNames('step-container', className)}>
      {children}
    </div>
  );
}

StepContainer.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.node,
    PropTypes.arrayOf(PropTypes.node),
  ]).isRequired,
  className: PropTypes.string,
  id: PropTypes.string,
};

StepContainer.defaultProps = {
  className: undefined,
  id: undefined,
};
